import request from '@/common/request/request'

function apply(data) { return request({ url: '/Agent/Apply', method: 'post', data }) }

export default {
  apply
}
